/* tslint:disable */
/* eslint-disable */
/**
 * Mclarens.OutlookAddin.Api.WebApi | v1
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface UpdateTaskResponse
 */
export interface UpdateTaskResponse {
    /**
     * 
     * @type {any}
     * @memberof UpdateTaskResponse
     */
    taskId: any | null;
    /**
     * 
     * @type {string}
     * @memberof UpdateTaskResponse
     */
    message: string;
}

/**
 * Check if a given object implements the UpdateTaskResponse interface.
 */
export function instanceOfUpdateTaskResponse(value: object): value is UpdateTaskResponse {
    if (!('taskId' in value) || value['taskId'] === undefined) return false;
    if (!('message' in value) || value['message'] === undefined) return false;
    return true;
}

export function UpdateTaskResponseFromJSON(json: any): UpdateTaskResponse {
    return UpdateTaskResponseFromJSONTyped(json, false);
}

export function UpdateTaskResponseFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateTaskResponse {
    if (json == null) {
        return json;
    }
    return {
        
        'taskId': json['taskId'],
        'message': json['message'],
    };
}

export function UpdateTaskResponseToJSON(value?: UpdateTaskResponse | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'taskId': value['taskId'],
        'message': value['message'],
    };
}

